import { Component, HostBinding } from '@angular/core';

/** Single error message to be shown underneath the form field. */
@Component({
  selector: 'mui-form-field-error',
  template: '<ng-content></ng-content>',
  styles: [':host {display: block; overflow: hidden}']
})
export class MuiFormFieldError {
  @HostBinding('class')
  class = 'mui-input__error__msg';

  @HostBinding('attr.aria-live')
  readonly ariaLive = 'polite';
}
